import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import ForgotEmail from './ForgotEmail';
import SecurityQuestion from './SecurityQuestion';
import UserDetails from './UserDetails';

// Hooks
import { useLookUpUser } from '@hooks/index';


const ForgotEmailContainer = (props) => {

    const { lookUpUserDetails, formSubmitted, userResponse, getUserSecurityQuestion, postSecurityAnswer, resetForm } = useLookUpUser();
    
    const { environment } = props;

    const gridStyle = {
        width: '560px',
    };
 
    const onSubmit = (data) => {
        getUserSecurityQuestion(data);
    };

    const onSubmitAnswer = (data) => {
        lookUpUserDetails.securityQuestions.userSecQstnAnsList[0].answer = data.answer;
        postSecurityAnswer({
            'encUserId': lookUpUserDetails.encUserId,
            'securityQuestions': lookUpUserDetails.securityQuestions
        });
    };

    const tryAgain = () => {
        resetForm();
    };

    const renderNextStep = () => {
        if (userResponse?.status === 'SUCCESS') {
            return <UserDetails userDetails={userResponse} environment={environment} />;
        } else {
            if (!formSubmitted) {
                return <ForgotEmail onSubmit={onSubmit} environment={environment} /> ;
            } else
                return <SecurityQuestion {...{ userResponse, lookUpUserDetails, tryAgain, onSubmitAnswer, environment }}/>;
        }
    };


    return (
        <Fragment>
            <main className="usa-layout-docs usa-section gi-main-section gi-panel">  
                <div className="grid-container" style={gridStyle} >
                    <div className="grid-row">
                        <div className="grid-col-12">
                            <h1> <FormattedMessage id='anonymous.forgot_email.header'/> </h1>
                        </div>
                    </div>
                    <div className="gi-panel">
                        <div className="grid-row">
                            { renderNextStep() }
                        </div>
                    </div>
                </div>
            </main>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});
export default connect(mapStateToProps)(ForgotEmailContainer);